import { StyleSheet } from 'react-native';

import { commonInput, commonLabel } from '../common';
import { colors, spacing, layout, typography } from '../theme';

export const inputStyles = StyleSheet.create({
	// Base input styles
	input: {
		...commonInput,
		marginBottom: spacing.m,
		padding: spacing.s,
	},

	// Text input label
	label: {
		...commonLabel,
		marginVertical: spacing.s,
		fontSize: typography.fontSize.body,
		color: colors.textSecondary,
	},

	// Row for multiple inputs
	row: {
		flexDirection: 'row',
		justifyContent: 'space-between',
	},

	// Different widths for row fields
	cityInput: {
		flex: 2,
		marginRight: spacing.s,
	},
	stateInput: {
		flex: 1,
		marginHorizontal: spacing.s,
	},
	zipInput: {
		flex: 1,
		marginLeft: spacing.s,
	},

	// Picker container styling
	pickerContainer: {
		borderWidth: 1,
		borderColor: colors.border,
		borderRadius: layout.borderRadius.small,
		marginBottom: spacing.m,
	},

	picker: {
		height: 50,
	},

	// Date picker container
	dateContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: spacing.m,
	},

	dateButton: {
		flex: 1,
		marginRight: spacing.s,
	},
	placeholder: {
		color: colors.textSecondary,
	},
});
